import React from 'react'
import styled from 'styled-components'

const SVG = styled.svg`
  height: 32px;
  width: 32px;

  path {
    fill: #b2bbbd;
  }
`

function Bell(props) {
  return (
    <SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <g transform="translate(3.000000, 2.000000)">
        <path
          d="M8.5,20 C9.6,20 10.5,19.1 10.5,18 L6.5,18 C6.5,19.1 7.4,20 8.5,20 L8.5,20 Z M15,14 L15,8.5 C15,5.43 12.87,2.86 10,2.18 L10,1.5 C10,0.67 9.33,0 8.5,0 C7.67,0 7,0.67 7,1.5 L7,2.18 C4.13,2.86 2,5.43 2,8.5 L2,14 L0,16 L0,17 L17,17 L17,16 L15,14 L15,14 Z"
          id="Shape"
        ></path>
      </g>
    </SVG>
  )
}

export default Bell



// WEBPACK FOOTER //
// ./src/images/icons/Bell.js